import { Column, Row } from "@/components";
import { Skeleton } from "@/components/ui/skeleton";

export const SearchV2CandidateSkeleton = () => {
  /* Render */
  const render = () => {
    return (
      <Row className="items-start gap-5 border-b border-slate-200 px-2 py-8 last:border-b-0">
        <Column className="min-w-0 flex-1 gap-5">
          <Column className="gap-2.5">
            <Row className="items-center gap-2">
              <Skeleton className="h-5 w-36" />
              <Skeleton className="h-4 w-44" />
              <Skeleton className="h-5 w-20 rounded-full" />
              <Skeleton className="h-4 w-24" />
            </Row>
            <div className="grid max-w-3xl grid-cols-1 gap-y-2.5 pt-1">
              <Row className="items-center">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-56" />
              </Row>
              <Row className="items-center">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-44" />
              </Row>
              <Row className="items-center">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-32" />
              </Row>
              <Row className="items-center">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-52" />
              </Row>
            </div>
          </Column>
          <Column className="gap-2">
            <Skeleton className="h-4 w-28" />
            <Column className="gap-2.5 border-l-4 border-slate-200 pl-3">
              <Skeleton className="h-4 w-80" />
              <Skeleton className="h-4 w-64" />
            </Column>
          </Column>
          <Row className="items-center gap-2">
            <Skeleton className="h-7 w-24 rounded-md" />
            <Skeleton className="h-7 w-28 rounded-md" />
            <Skeleton className="h-7 w-20 rounded-md" />
          </Row>
          <Row className="items-center gap-2">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-4 w-72" />
          </Row>
        </Column>
        <Column className="items-end gap-2">
          <Skeleton className="h-9 w-28 rounded-md" />
        </Column>
      </Row>
    );
  };

  return render();
};
